module.exports = {
  BASE_PROD_API_URL: 'https://sourcetoomachine.com/wp-json/stm/v1',
  BASE_STG_API_URL: 'https://staging.sourcetoomachine.com/wp-json/stm/v1',
}